import { SIGNATORY_PERMISSION } from '../../../../../../constants/permissions'

export const getInitialValues = (memberData = {}) => {
  const { permissions = [] } = memberData

  return {
    [SIGNATORY_PERMISSION]: permissions.includes(SIGNATORY_PERMISSION)
  }
}
